import React from 'react';
import styled from 'styled-components';
import { tableIcons } from './TableIcons';
import Select from '@material-ui/core/Select';

const PaginationWrapper = styled.td`
    width: fit-content;
    display: flex;
    align-items: center;
    float: right;
    padding: 8px 8px;
`

const TextContainer = styled.div`
    padding-left: ${({isFirstPage}) => isFirstPage ? '40px' : '0'};
    padding-right: ${({isLastPage}) => isLastPage ? '40px' : '0'};
    margin-bottom: 4px;
`

export default function Pagination(props) {
    const maxPages = Math.ceil(props.itemCount/ props.rowsPerPage);

    const isFirstPage = props.currentPage + 1 === 1; 
    const isLastPage = props.currentPage === maxPages - 1;

    const prevIconStyle = {
        position: 'relative',
        cursor: 'pointer',
        margin: '0px 8px',
        display: isFirstPage? 'none' : 'inline'
    }

    const nextIconStyle={
        position: 'relative',
        cursor: 'pointer',
        margin: '0px 8px',
        display: isLastPage ? 'none' : 'inline'
    }

    function handleNextClicked(e) {
        if (props.currentPage + 1 < maxPages) {
            props.onChangePage(e, props.currentPage + 1);
            props.onNextClicked();
        }
    }

    function handlePrevClicked(e) {
        if (props.currentPage - 1 >= 0) {
            props.onChangePage(e, props.currentPage - 1);
            props.onPrevClicked();
        }
    }

    return (
        <PaginationWrapper>
            <Select
                defaultValue={props.rowsPerPageOptions[0]}
                disableUnderline={true}
                value={props.rowsPerPage}
                onChange={(e) => { 
                    props.onChangeRowsPerPage(e)
                }}
            >
                {props.rowsPerPageOptions.map((option, i) => {
                    return (
                        <li style={{cursor: 'pointer', display: 'block', margin: '4px 0'}} key={i} value={option}>{`${option} rows`}</li>
                    )
                })}
            </Select>
            <tableIcons.PreviousPage style={prevIconStyle} onClick={handlePrevClicked}/>
            <TextContainer isFirstPage={isFirstPage} isLastPage={isLastPage}>
                Page {props.currentPage + 1} of {maxPages}
            </TextContainer>
            <tableIcons.NextPage style={nextIconStyle} onClick={handleNextClicked}/>
        </PaginationWrapper>
    )
}